import type { IAhuAccessoryRow, IAhuBoardSection, ICmsAhuDoc } from 'models';
import LightForm from './types/LightForm';
import JboxForm from './types/JboxForm';
import DisconnectForm from './types/DisconnectForm';
import EnclosureForm from './types/EnclosureForm';
import AdpGageForm from './types/AdpGageForm';
import VfdForm from './types/VfdForm';
import DogHouseForm from './types/DogHouseForm';
import StarterForm from './types/StarterForm';
import DrainPanForm from './types/DrainPanForm';
import UdaForm from './types/UdaForm';
import AccessDoorForm from './types/AccessDoorForm';
import OpeningForm from './types/OpeningForm';
import UvcForm from './types/UvcForm';
import LouverForm from './types/LouverForm';
import HoodForm from './types/HoodForm';
import DamperForm from './types/DamperForm';
import AmsForm from './types/AmsForm';

/**
 * Phase 6e2b — accessory form factory, COMPLETE (§53.3 build order):
 * 6e2b-1 shipped the 10 simpler types; 6e2b-2 adds the 7 complex ones
 * (access_door, opening, uvc, louver, hood+damper as one unit, ams).
 * All 17+ams accessory types now render React.
 */

export interface AccessoryFormProps {
  row: IAhuAccessoryRow;
  section: IAhuBoardSection;
  tunnel?: { width?: unknown; height?: unknown } | null;
  cms?: ICmsAhuDoc;
  expanded: boolean;
}

const FORMS: Record<string, (props: AccessoryFormProps) => JSX.Element> = {
  light: LightForm,
  jbox: JboxForm,
  disconnect: DisconnectForm,
  enclosure: EnclosureForm,
  adp_gage: AdpGageForm,
  vfd: VfdForm,
  dog_house: DogHouseForm,
  starter: StarterForm,
  drain_pan: DrainPanForm,
  user_defined_accessory: UdaForm,
  access_door: AccessDoorForm,
  opening: OpeningForm,
  uvc: UvcForm,
  louver: LouverForm,
  hood: HoodForm,
  damper: DamperForm,
  ams: AmsForm,
};

export const isAccessoryFormBuilt = (type: string): boolean => !!FORMS[type];

const AccessoryFormHost = (props: AccessoryFormProps) => {
  const type = String(props.row.type ?? '');
  const Form = FORMS[type];
  if (!Form) return <div className="preloader dotted-preloader active" />;
  return <Form {...props} />;
};

export default AccessoryFormHost;
